import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const NAV_MAP: Record<string, string> = {
  d: '/dashboard',
  a: '/applications',
  c: '/calendar',
  q: '/queue',
  n: '/notifications',
  r: '/resumes',
  w: '/workers',
  s: '/settings',
};

interface Options {
  onSearch?: () => void;
  onHelp?: () => void;
}

export function useKeyboardShortcuts({ onSearch, onHelp }: Options = {}) {
  const navigate = useNavigate();

  useEffect(() => {
    let lastKey = '';
    let lastTs = 0;

    function handler(e: KeyboardEvent) {
      // Ignore when typing in inputs/textareas/contenteditable
      const t = e.target as HTMLElement | null;
      if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) {
        return;
      }
      if (e.metaKey || e.ctrlKey || e.altKey) return;

      // `?` opens help
      if (e.key === '?') {
        onHelp?.();
        e.preventDefault();
        return;
      }
      // `/` focuses search
      if (e.key === '/') {
        onSearch?.();
        e.preventDefault();
        return;
      }

      // Two-key combos: g d -> dashboard, etc.
      if (lastKey === 'g' && Date.now() - lastTs < 1000) {
        const dst = NAV_MAP[e.key.toLowerCase()];
        if (dst) {
          navigate(dst);
          lastKey = '';
          e.preventDefault();
          return;
        }
      }
      if (e.key.toLowerCase() === 'g') {
        lastKey = 'g';
        lastTs = Date.now();
      } else {
        lastKey = '';
      }
    }
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [navigate, onSearch, onHelp]);
}
